<template>
  <Container type="card-full">
        <div  v-loading="loading">
            <div slot="header" style="height:60px;overflow:hidden;color:red;font-size:18px;">
                <div style="float:left;">
                    <div>
                        {{!this.pds.pdsstaus?'【编制中】':this.pds.pdsstaus === 1?'【编制中】':this.pds.pdsstaus === 2?'【审核中】':'【已归档】'}}
                    </div>
                </div>
                <div v-if="+this.$store.getters.loginUser.rolecomtype !== 2">
                    <div style="float:right" v-if="+this.$store.getters.loginUser.roletype !== 6">
                        <div v-show="(+this.pds.pdsstaus === 1 || !this.pds.pdsstaus)
                        && +$store.getters.loginUser.roletype !== 5">
                            <el-button @click="uplodFile" :loading="btnLoading" type="primary">上传附件</el-button>
                            <el-button @click="ViewPdsFile" v-if="pds.pdsid" :loading="btnLoading" type="primary">查阅档案</el-button>
                            <el-button @click="addOrEdit" :loading="btnLoading" type="primary">保存</el-button>
                            <el-button @click="showDialogS" :loading="btnLoading" type="primary">提交</el-button>
                        </div>
                        <div v-show="+this.pds.pdsstaus === 2 
                        && +$store.getters.loginUser.roletype === 5">
                            <el-button @click="ViewPdsFile" v-if="pds.pdsid" :loading="btnLoading" type="primary">查阅档案</el-button>
                            <el-button @click="addOrEdit" :loading="btnLoading" type="primary">保存</el-button>
                            <el-button @click="showDialogR" :loading="btnLoading" type="primary">审核</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main">
                <div class="view-container">
                    <div class="view-box">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">委托单位</div>
                                <div class="view-value">
                                    {{project.Pcomname}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">协议编号</div>
                                <div class="view-value">
                                    {{project.projectptccode}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">业务员</div>
                                <div class="view-value">
                                    {{project.Susername}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="view-box">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">代理单位</div>
                                <div class="view-value">
                                    {{project.Acomname}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">项目编号</div>
                                <div class="view-value">
                                    {{project.projectcode}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">项目员</div>
                                <div class="view-value">
                                    {{project.Cusername}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="view-box">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">项目名称</div>
                                <div class="view-content" style="width:611px;">
                                    {{project.projectname}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">项目公告</div>
                                <div class="view-value">
                                    {{project.pjnoticetime | newDate}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="view-box">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label" style="line-height:40px;">项目预算</div>
                                <div class="view-val" style="color:#999;width: 250px;">
                                    <div>
                                        ￥{{project.projectlimitamt | qfwVal}}元
                                    </div>
                                    <div>
                                        (<amount :money="String(project.projectlimitamt)"/>)/{{project.projecthsflg?'含税':'不含税'}}
                                    </div>
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">交易方式</div>
                                <div class="view-value">
                                    {{project.prsflgdesc}}—{{project.projectquotationmodedesc}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">评审方法</div>
                                <div class="view-value">
                                    {{project.projectdoneflgdesc}}—{{project.projectpricecomputebasisdesc}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="view-box">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">报名截止</div>
                                <div class="view-value">
                                    {{project.prsbmendtime | longDate}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">有效报名</div>
                                <div class="view-value">
                                    {{project.psuYXcount}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="view-box">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">竞价开始</div>
                                <div class="view-value">
                                    {{project.prsbjbegtime | longDate}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">有效报价</div>
                                <div class="view-value">
                                    {{project.psuYXBMcount}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">交易结果</div>
                                <div class="view-value">
                                    {{project.iscjgg>0?'成交':'失败'}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="view-box" v-for="i in this.psuZB" :key="i.psuid">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">成交单位</div>
                                <div class="view-value">
                                    {{i.comfullname}}
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label" style="line-height:40px;">成交金额</div>
                                <div  class="view-val" style="color:#999;width: 250px;">
                                    <div>
                                        ￥{{i.psuamt | qfwVal}}元
                                    </div>
                                    <div>
                                        (<amount :money="String(i.psuamt)"/>)
                                    </div>
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label">联系方式</div>
                                <div class="view-value">
                                    {{i.psucontactname}}{{i.psucontactphone}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <vggrid ref="xGrid" :list="list" tableheight="300" flexname="" :cols="cols"
                        :showfooter="false" :showPage="false" :resizable="true"
                        @cellClick="cellClick"
                    :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick"
                >
                    <template slot="btn">
                        <div class="btn-box">
                        </div>
                    </template>
                </vggrid>
                <div  class="view-container swbox" v-if="hasInkind === 1">
                    <div class="view-box">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">实物</div>
                                <div class="view-value">
                                    <el-radio-group v-model="hasInkind" :disabled="true">
                                        <el-radio :label="1">有</el-radio>
                                        <el-radio :label="2">无</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="view-field">
                                <div class="view-label" style="margin-top:10px;">实物存放地点</div>
                                <div class="view-val" style="width:480px;">
                                    <el-input v-model="pds.pdsgoodsaddr" placeholder="请输入存放地点容"  
                                    maxlength="200"
                                    show-word-limit></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="view-box" v-show="+hasInkind === 1">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">实物描述</div>
                                <div class="view-con">
                                    <el-input
                                        :disabled="this.showFlg"
                                        rows="6"
                                        type="textarea"
                                        placeholder="请输入内容"
                                        v-model="pds.pdsgoodsdesc"
                                        maxlength="200"
                                        show-word-limit
                                    >
                                    </el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div  class="swbox" style="padding:10px;" v-if="pds.submitName">
                <div class="view-bt">
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">申请人</div>
                        <div class="view-bt-item-r">{{pds.submitName}}</div>
                    </div>
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">申请时间</div>
                        <div class="view-bt-item-r">{{pds.pdssubmittime | longDate}}</div>
                    </div>
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">意见</div>
                        <div class="view-bt-item-r">{{pds.pdssubmitcontent}}</div>
                    </div>
                </div>
            </div>
            <div  class="swbox" style="padding:10px;" v-if="pds.reviewName">
                <div class="view-bt">
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">审核人</div>
                        <div class="view-bt-item-r">{{pds.reviewName}}</div>
                    </div>
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">审核时间</div>
                        <div class="view-bt-item-r">{{pds.pdschecktime | longDate}}</div>
                    </div>
                    <div class="view-bt-item">
                        <div class="view-bt-item-l">意见</div>
                        <div class="view-bt-item-r">{{pds.pdscheckcontent}}</div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="提交"
            :visible.sync="this.dialogVisible"
            width="70%"
            :before-close="handleClose">
            <div class="main">
                <el-form :model="pds" ref="ruleForm" label-position="right" class="mainfrom from_input">
                    <div class="row">
                        <el-form-item label="提交意见" prop="pdscheckcontent">
                            <el-input 
                                rows="6"
                                type="textarea"
                                placeholder="请输入意见"
                                v-model="pds.pdssubmitcontent"
                                maxlength="250"
                                show-word-limit
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="审核"
            :visible.sync="this.reviewVisible"
            width="70%"
            :before-close="handleClose">
            <div class="main">
                <el-form :model="pds" ref="ruleForm" label-position="right" class="mainfrom from_input">
                    <div class="row">
                        <el-form-item label="审核" prop="radioFlg">
                            <el-radio-group v-model="radioFlg" style="margin-top:10px;">
                                <el-radio label="3">通过</el-radio>
                                <el-radio label="1">不通过</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="row">
                        <el-form-item label="审核意见" prop="pdscheckcontent">
                            <el-input 
                                rows="6"
                                type="textarea"
                                placeholder="请输入审核意见"
                                v-model="pds.pdscheckcontent"
                                maxlength="250"
                                show-word-limit
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="reviewPds">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="附件"
            :visible.sync="this.uplodFileFlg"
            width="70%"
            :before-close="handleClose">
            <div class="main">
                <div class="view-container">
                    <div class="view-box">
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">协议附件</div>
                                <div v-if="ptcAppendList.length>0" class="view-filelist">
                                    <div v-for="(item,index) in ptcAppendList" :key="index" class="view-fileitem">
                                        <div class="view-filename" @click="downFile(item.appendurl)">
                                            <a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                                        </div>
                                        <div class="cbtn" @click="delPtcappend(item)"><span>删除</span></div>
                                    </div>
                                </div>
                                <div v-else class="view-value">
                                    <upload-btn @changed='setPtcfile' text="上传附件"></upload-btn>
                                </div>
                            </div>
                        </div>
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">成交确认函</div>
                                <div v-if="cjAppendList.length>0" class="view-filelist">
                                <div v-for="(item,index) in cjAppendList" :key="index" class="view-fileitem">
                                    <div class="view-filename" @click="downFile(item.appendurl)">
                                        <a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                                    </div>
                                    <div class="cbtn" @click="delCjappend(item)"><span>删除</span></div>
                                </div>
                                </div>
                                <div v-else class="view-value">
                                    <upload-btn @changed='setCJfile' text="上传附件"></upload-btn>
                                </div>
                            </div>
                        </div>
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label">其它附件</div>
                                <div>
                                    <div class="view-value">
                                        <upload-btn @changed='setOtherFile' text="上传附件"></upload-btn>
                                    </div>
                                    <div class="view-filelist"  v-if="otherAppendList.length>0">
                                            <div v-for="(item,index) in otherAppendList" :key="index" class="view-fileitem">
                                                <div class="view-filename" @click="downFile(item.appendurl)">
                                                    <a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                                                </div>
                                                <div class="cbtn" @click="delOtherAppend(item)"><span>删除</span></div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="saveFile">保 存</el-button>
            </span>
        </el-dialog>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import _ from 'lodash'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'
  import utils from '../../assets/js/utils'
  import amount from '../common/amount'
  import vggrid from '../common/vggrid'
  import uploadBtn from '../common/uploadBtn'
  import { divide } from 'xe-utils/methods'

  export default {
    name: "xmgdFrom",
    mixins: [common],
    data () {
      return {
          btnLoading:false,
          dialogVisible:false,
          reviewVisible:false,
          uplodFileFlg:false,
          ptcAppendList:[],
          cjAppendList:[],
          otherAppendList: [],
          loading:false,
          pds:{
              pdsgoodsdesc:'2'
          },
          project:{},
          isOperate:false,
          psuZB:[],
          type:null,
          operateBtn:[],
          radio:"",
          radioFlg:'',
          cols:[
            { field: 'pdsltcode', fieldtype: 'C', title: '编号',calculExpr:'',addNewRowFlg: false,width:80},
            { field: 'pdsltname', fieldtype: 'C', title: '目录名称',calculExpr:'',addNewRowFlg: false,width:200},
            { title: '自查', width: 80, showOverflow: true,
                slots: {
                default: 'default',
                default: ({row}) => {
                    return [
                        <el-checkbox v-model={row.pdsltselfcheckflag} disabled={this.showFlg}></el-checkbox>
                    ]
                }}
            },
            { title: '实物文件', width: 160, showOverflow: true,
                slots: {
                default: 'default',
                default: ({row}) => {
                    return [
                        <el-radio-group v-model={row.pdsltgoodsflag} disabled={this.showFlg} onChange={this.existence.bind(this, row)}>
                            <el-radio label="1">有</el-radio>
                            <el-radio label="2">无</el-radio>
                        </el-radio-group>
                    ]
                }}
            },
            { title: '自查说明', showOverflow: false,
                slots: {
                default: 'default',
                default: ({row}) => {
                    if(this.pds){
                        if(+this.pds.pdsstaus !== 2){
                            return [
                                <el-input placeholder="请输入自查说明" maxlength="255" show-word-limit v-model={row.pdsltselfcheckcontent} 
                            disabled={this.showFlg} clearable ></el-input>
                            ]
                        }else{
                            return [<span>{row.pdsltselfcheckcontent}</span>]
                        }
                    }
                }}
            }
          ],
          itemArr:[
                { title: '审查', width: 80, showOverflow: true,
                    slots: {
                    default: 'default',
                    default: ({row}) => {
                        return [
                            <el-checkbox v-model={row.pdsltcheckflag} 
                            disabled={!this.showFlg} ></el-checkbox>
                        ]
                    }}
                },
                { title: '审查说明', showOverflow: false,
                    slots: {
                    default: 'default',
                    default: ({row}) => {
                        if(this.pds){
                            if(+this.pds.pdsstaus !== 2){
                                return [<span>{row.pdsltcheckcontent}</span>]
                            }else{
                                return [
                                    <el-input placeholder="请输入审查说明" disabled={!this.showFlg} 
                                    v-model={row.pdsltcheckcontent} maxlength="255" show-word-limit clearable></el-input>
                                ]
                            }
                        }
                    }}
                }
          ],
          list:[],
          pList:[]
      }
    },
    async created () {
    },
    async mounted () {
      await this.init()
    },
    async activated () {
      await this.init()
      await this.getPdsTem()
      await this.getpdsInfo()
    },
    components: {amount,vggrid,uploadBtn},
    computed: {
        uploadAddr () {
            return this.$store.getters.uploadAddr
        },
        hasInkind(){
            let index = this.list.findIndex(e=>{
                return +e.pdsltgoodsflag === 1
            })
            if(index === -1){
                this.pds.pdsltgoodsflag = 2
                this.pds.pdsgoodsaddr = ' '
                this.pds.pdsgoodsdesc = ' '
                return 2
            }else{
                this.pds.pdsltgoodsflag = 1
                return 1
            }
        },
        showFlg(){
            if(!this.pds.pdsstaus){
                return false
            }
            else if(+this.pds.pdsstaus===1){
                return false
            }
            else{
                return true
            }
        }
    },
    filters: {
      longDate (value) {
        return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      newDate (value) {
        return dayjs(value).format('YYYY-MM-DD')
      },
      qfwVal (value) {
        if (!!value && +value > 0) {
          return utils.comdify(value)
        } else {
          return value
        }
      }
    },
    methods: {
        async init(){
            this.type= this.$route.params.type
            this.pds = {}
            this.list = []
        },
        async getPdsTem(){
            let temType = this.$route.params.temType
            let res = await request({
                url: '/xmgl/pds/getPdsTem',
                method: "get",
                params: {temType:temType}
            })
            res.map(e=>{
                e.pdsltselfcheckflag = +e.pdsltselfcheckflag === 1?false:true
                e.pdsltgoodsflag = String(e.pdsltgoodsflag)
                e.pdsltselfcheckcontent = '自查无误'
                e.pdsltcheckcontent = "审查无误"
                e.pdsltcheckflag = +e.pdsltcheckflag === 2?true:false
            })
        },
        vggridClick(code,row){
            // this.append = row
            // this.$emit(code,row)
        },
        async cellClick (row) {
            // this.append = row.row
        },
        descInputChange (row, e) {
            row.pdslselfcheckcontent = e.target.value
        },
        async getpdsInfo(){
            this.loading = true
            this.btnLoading = true
            let res = await request({
                url: '/xmgl/pds/getpdsInfo',
                method: "get",
                params: {
                      projectid: this.$route.params.projectid,
                      cosid:this.$store.getters.loginUser.cosid
                    }
            })

            let psuYXList = res.PSUdata.filter(e=>{
                return e.psuas != null 
            })

            this.psuZB = res.PSUdata.filter(e=>{
                return +e.psubidflg === 1 
            })
            this.project = res.PJdata
            if(res.PDSLdata.length>0){
                this.pds = res.PDSdata[0]
            }
            if(res.PDSLdata.length>0){
                if(+this.pds.pdsstaus > 1){
                    res.PDSLdata = res.PDSLdata.filter(e=>{
                        return +e.pdslselfcheckflag === 2 
                    })
                }
                res.PDSLdata.forEach(e => {
                    e.pdsltselfcheckflag = +e.pdslselfcheckflag === 1 ? false:true
                    e.pdsltcheckflag = +e.pdslcheckflag === 2?true:false
                    e.pdsltgoodsflag = String(e.pdslgoodsflag)
                    e.pdsltselfcheckcontent = e.pdslselfcheckcontent?e.pdslselfcheckcontent:'自查无误'
                    e.pdsltcheckcontent = e.pdslcheckcontent?e.pdslcheckcontent:"审查无误"
                    e.pdsltcode = e.pdslcode
                    e.pdsltname = e.pdslname
                });
                res.PDSLdata.forEach(e => {
                    if (e.pdsltcode === 'P15') {
                        e.pdsltselfcheckflag = res.PDSdata[0] && res.PDSdata[0].pjnoticeotherid !== null && res.PDSdata[0].pjnoticeotherid !== ''
                    }
                });
                this.list = res.PDSLdata
            }
            if((this.pds.pdscheckuserid && +this.pds.pdsstaus === 1) || this.pds.pdsstaus > 1){
                let index = this.cols.findIndex(e=>{
                    return e.title == '审查'
                })
                if(index == -1){
                    this.itemArr.forEach(e=>{
                        this.cols.push(e)
                    })
                }
            }
            //有效报名projectbmamt  projectbzjamt
            let psuYXBM = res.PSUdata.filter(e=>{
                // if(+e.psustatus === 3){
                    if(res.PJdata.projectbzjamt > 0){
                        return +e.psubzjpayflg === 1 && +e.psustatus === 3
                    }
                    else if(res.PJdata.projectbmamt > 0){
                        return +e.psubmpayflg === 1 && +e.psustatus === 3
                    } else{
                        return +e.psustatus === 3
                    }
                // }
            })
            this.project.psuYXBMcount = psuYXBM.length
            this.project.psuCount = res.PSUdata.length
            this.project.psuYXcount = psuYXList.length
            this.project.iscjgg = res.PJNdata.length
            this.loading = false
            this.btnLoading = false
        },
        async submit(){
            this.loading = true
            this.btnLoading = true
            this.pds.projectid = this.project.projectid
            this.pds.cosid = this.$store.getters.loginUser.cosid
            this.pds.pdssubmituserid = this.$store.getters.loginUser.userid  //提交人
            this.pds.pdsstaus = 2  //状态
            this.pds.pdsgoodsflag = this.hasInkind
            this.pds.pdscreateuserid =  this.pds.pdscreateuserid?this.pds.pdscreateuserid:this.$store.getters.loginUser.userid   //创建人
            this.pds.pdsmodifyuserid = this.pds.pdsmodifyuserid?this.pds.pdsmodifyuserid:this.$store.getters.loginUser.userid   //修改人
            let ilist = this.list.map(e=>{
                e.pdslselfcheckflag = e.pdsltselfcheckflag == true ? '2':'1'
                e.pdslcheckflag = e.pdsltcheckflag == true ? '2':'1'
                e.pdslname = e.pdsltname
                e.pdslcode = e.pdsltcode
                e.pdslgoodsflag = e.pdsltgoodsflag
                e.pdslselfcheckcontent = e.pdsltselfcheckcontent
                e.pdslcheckcontent = e.pdsltcheckcontent
                e.pdslcheckflag = 2
                return e
            })
            this.$confirm(`是否确认提交`, '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(async () => {
                let res = await request({
                    url: '/xmgl/pds/submitPds',
                    method: "post",
                    data: {pds:this.pds,list:ilist}
                })
                if(res.issuccess === 1){
                    this.close()
                    this.dialogVisible = false
                    this.btnLoading = true
                    this.$message.success('提交成功')
                }
            }).catch(() => {
            })
            this.loading = false
            this.btnLoading = true
        },
        async addOrEdit(){
            let index  = this.list.every(e=>{
                return !e.pdsltselfcheckflag
            })
            if(index){
                this.$message.warning('清单列表未勾选，不需要归档')
                return
            }
            this.loading = true
            this.pds.projectid = this.project.projectid
            this.pds.cosid = this.$store.getters.loginUser.cosid
            this.pds.pdsgoodsflag = this.hasInkind
            this.pds.pdsstaus = this.pds.pdsstaus  //状态
            this.pds.pdscreateuserid =  this.$store.getters.loginUser.userid   //创建人
            this.pds.pdsmodifyuserid = this.$store.getters.loginUser.userid   //修改人
            let ilist = this.list.map(e=>{
                e.pdslselfcheckflag = e.pdsltselfcheckflag == true ? '2':'1'
                e.pdslcheckflag = e.pdsltcheckflag == true ? '2':'1'
                e.pdslname = e.pdsltname
                e.pdslcode = e.pdsltcode
                e.pdslgoodsflag = e.pdsltgoodsflag
                e.pdslselfcheckcontent = e.pdsltselfcheckcontent || null
                e.pdslcheckcontent = e.pdsltcheckcontent || null
                return e
            })
            let res = await request({
                url: '/xmgl/pds/submitPds',
                method: "post",
                data: {pds:this.pds,list:ilist}
            })
            if(res.issuccess === 1){
                await this.getpdsInfo()
                this.$message.success('保存成功')
            }
            this.loading = false
        },
        // async savepds(){
        //     this.loading = true
        //     this.pds.projectid = this.project.projectid
        //     this.pds.cosid = this.$store.getters.loginUser.cosid
        //     this.pds.pdsstaus = 2  //状态
        //     let ilist = this.list.map(e=>{
        //         e.pdslselfcheckflag = e.pdsltselfcheckflag == true ? '2':'1'
        //         e.pdslcheckflag = e.pdsltcheckflag == true ? '2':'1'
        //         e.pdslname = e.pdsltname
        //         e.pdslcode = e.pdsltcode
        //         e.pdslgoodsflag = e.pdsltgoodsflag
        //         e.pdslselfcheckcontent = e.pdsltselfcheckcontent
        //         e.pdslcheckcontent = e.pdsltcheckcontent
        //         return e
        //     })
        //     let res = await request({
        //         url: '/xmgl/pds/submitPds',
        //         method: "post",
        //         data: {pds:this.pds,list:ilist}
        //     })
        //     if(res.issuccess === 1){
        //         await this.getpdsInfo()
        //         this.$message.success('保存成功')
        //     }
        //     this.loading = false
        // },
        async reviewPds(){
            this.loading = true
            if(!this.radioFlg){
                this.$message.warning("请选择审核状态")
                this.loading = false
                return
            }
            this.pds.projectid = this.project.projectid
            this.pds.cosid = this.$store.getters.loginUser.cosid
            this.pds.pdsstaus = this.radioFlg  //状态
            this.pds.pdscheckuserid =  this.$store.getters.loginUser.userid   //审核人
            let ilist = this.list.map(e=>{
                e.pdslcheckflag = e.pdsltcheckflag == true ? '2':'1'
                e.pdslcheckcontent = e.pdsltcheckcontent
                return e
            })
            this.$confirm(`是否确认审核`, '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(async () => {
                let res = await request({
                    url: '/xmgl/pds/reviewPds',
                    method: "post",
                    data: {pds:this.pds,list:ilist}
                })
                if(res.issuccess === 1){
                    this.reviewVisible = false
                    this.close()
                    this.$message.success('保存成功')
                }
            }).catch(() => {
            })
            this.loading = false
        },
        close () {
            this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'xmgd'})
        },
        showDialogS(){
            let index  = this.list.every(e=>{
                return !e.pdsltselfcheckflag
            })
            if(index){
                this.$message.warning('清单列表未勾选，不需要归档')
                return
            }
            this.dialogVisible = true
        },
        showDialogR(){
            this.reviewVisible = true
        },
        handleClose(){
            this.dialogVisible = false
            this.reviewVisible = false
            this.uplodFileFlg = false
        },
        existence(e){
            let Arr = []
            let pdsCON = this.pds.pdsgoodsdesc?this.pds.pdsgoodsdesc:''
            this.$set(this.pds,'pdsgoodsdesc',pdsCON)
            if(+e.pdsltgoodsflag === 1){
                Arr.push({
                    pdsltcode:e.pdsltcode,
                    pdsltname:e.pdsltname
                })
            }
            for(let i in Arr){
                this.pds.pdsgoodsdesc += this.pds.pdsgoodsdesc?'/':''
                this.pds.pdsgoodsdesc += Arr[i].pdsltname
                this.$set(this.pds,'pdsgoodsdesc',this.pds.pdsgoodsdesc)
            }
            // this.$forceUpdate()
        },
        async ViewPdsFile(){
          let {href} = this.$router.resolve({name: 'archives', 
          query: {projectid:this.project.projectid,ptcid:this.project.projectptcid,projectcode:this.project.projectcode,cosid:this.project.projectcosid}})
          window.open(href, '_blank')
        },
        delPtcappend (file) {
            this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
            type: 'warning'
            }).then(() => {
            let index = this.ptcAppendList.findIndex((val) => val.appendfilename === file.appendfilename)
            this.ptcAppendList.splice(index, 1)
            }).catch(() => {
            })
        },
        delCjappend (file) {
            this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
            type: 'warning'
            }).then(() => {
            let index = this.cjAppendList.findIndex((val) => val.appendfilename === file.appendfilename)
            this.cjAppendList.splice(index, 1)
            }).catch(() => {
            })
        },
        delOtherAppend (file) {
            this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
                type: 'warning'
            }).then(() => {
                let index = this.otherAppendList.findIndex((val) => val.appendfilename === file.appendfilename)
                this.otherAppendList.splice(index, 1)
            }).catch(() => {
            })
        },
        async setPtcfile (path, filename) {
            let append = {
                appendid: 0,
                appendfromid: this.project.projectptcid,
                appendfromtype: '22',
                appendtype: '100',
                appendseq: this.ptcAppendList.length + 1,
                appendfilecode: '',
                appendfilename: filename,
                appendurl: path.replace(this.uploadAddr, '')
            }
            this.ptcAppendList.push(append)
        },
        async setCJfile (path, filename) {
            let append = {
                appendid: 0,
                appendfromid: this.project.projectid,
                appendfromtype: '23',
                appendtype: '100',
                appendseq: this.cjAppendList.length + 1,
                appendfilecode: '',
                appendfilename: filename,
                appendurl: path.replace(this.uploadAddr, '')
            }
            this.cjAppendList.push(append)
        },
        async setOtherFile (path, filename) {
            let append = {
                appendid: 0,
                appendfromid: this.pds.pdsid,
                appendfromtype: '99',
                appendtype: '99',
                appendseq: this.otherAppendList.length + 1,
                appendfilecode: '',
                appendfilename: filename,
                appendurl: path.replace(this.uploadAddr, '')
            }
            this.otherAppendList.push(append)
        },
        async uplodFile(){
            await this.getFileList()
            this.uplodFileFlg = true
        },
        async saveFile(){
            this.loading = true

            let res = await request({
                url: '/xmgl/pds/saveFile',
                method: "Post",
                data: {
                    pdsid: this.pds.pdsid,
                    ptcid:this.project.projectptcid,
                    projectid:this.project.projectid,
                    ptcAppendList:this.ptcAppendList,
                    cjAppendList:this.cjAppendList,
                    otherAppendList:this.otherAppendList
                }
            })
            if(+res.issuccess === 1){
                this.uplodFileFlg = false
                this.loading = false
            }
        },
        async getFileList(){
            let res = await request({
                url: '/xmgl/pds/getFileList',
                method: "get",
                params: {projectid: this.project.projectid,ptcid:this.project.projectptcid, pdsid: this.pds.pdsid}
            })
            this.ptcAppendList = res.ptcList
            this.cjAppendList = res.cjList
            this.otherAppendList = res.otherList
        }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/filelist";
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content-title{
      display: flex;
      .el-input{
        width: 514px;
      }
      .el-cascader{
        width: 200px;
      }
    }
    .content .el-textarea__inner, .el-textarea {
      width: 840px;
    }
    .file {
      display: flex;
      flex-direction: column;
      // width: 50%;
      .uploadbtn {
        display: flex;
        span {
          padding-left: 10px;
          color: red;
        }
      }
    }
    .checkbox_w {
      width: 45px;
    }
  }
  .swbox{
      margin-top: 10px;
      -moz-box-shadow:0px 0px 1px #333333; -webkit-box-shadow:0px 0px 1px #333333; box-shadow:0px 0px 1px #333333;
  }
.view-bt{
    display: flex;
    .view-bt-item{
        display: flex;
        .view-bt-item-l{
            width: 110px;
            margin-right: 10px;
            text-align: right;
        }
        .view-bt-item-r{
            color: #999999;
            margin-right: 20px;
            max-width: 600px;
        }
    }
}
.cbtn{
    color: #409EFF;
    cursor: pointer;
    margin-left: 10px;
}
</style>
